<template>
    <div class="incoming-wrap">
        <div style="display: flex; justify-content: space-between;">
            <div class="leader-radio">
                <el-radio-group
                    v-model="selectAccount"
                    v-for="item in accounts"
                    :key="item.elec_customer_account_id"
                    @change="toggleTab(item.elec_customer_account_id)"
                    size="medium"
                >
                    <el-radio-button
                        :label="item.account_name"
                        style="margin-right: 10px"
                    ></el-radio-button>
                </el-radio-group>
            </div>

            <div class="incoming-card-btn">
                <el-form
                    :inline="true"
                    :model="searchForm"
                    ref="searchForm"
                    :rules="searchFormRule"
                    class="leader-style-form"
                >
                    <el-form-item prop="selectDate" class="timePicker">
                        <el-date-picker
                            :picker-options="pickerDisabled"
                            v-model="searchForm.selectDate"
                            type="month"
                            placeholder="请选择时间"
                            :default-value="selectDate"
                            value-format="yyyy-MM"
                            format="yyyy-MM"
                            @change="yymm"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            icon="el-icon-caret-left"
                            @click="frontMonthClick"
                            size="medium"
                            class="time_btn"
                            >上一月</el-button
                        >
                        <el-button
                            @click="nextMonthClick"
                            :disabled="
                                this.sysDate === this.searchForm.selectDate
                            "
                            size="medium"
                            class="time_btn"
                        >
                            下一月
                            <i class="el-icon-caret-right"></i>
                        </el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            @click="search"
                            style="float:right;"
                            type="warning"
                            size="medium"
                            >查询</el-button
                        >
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <el-scrollbar style="height: 90%">
            <div class="echart-container">
                <div
                    style="text-align: left; font-size: 16px; border-left:5px solid #56fcff; color: #fff; margin-top: 20px; padding-left: 10px"
                >
                    月度用电趋势图
                </div>
                <div style="text-align: right; margin-bottom: 10px">
                    <el-button
                        class="leader-common-button"
                        @click="showYearChart('chart')"
                        >图表</el-button
                    >
                    <el-button
                        class="leader-common-button"
                        @click="showYearChart('table')"
                        >数据</el-button
                    >
                    <!-- <el-button
                        class="leader-common-button"
                        @click="exportMonthPowerAndCost"
                        >导出</el-button
                    > -->
                </div>
                <v-chart
                    :auto-resize="true"
                    :options="barYear"
                    ref="barYear"
                    theme="ovilia-green"
                    v-if="showYearCharts"
                    @click="clickYearBar"
                />
                <common-table
                    :tableData="tableYearData"
                    :columns="colsYear"
                    v-else
                ></common-table>

                <template v-if="showMonth">
                    <div
                        style="text-align: left; font-size: 16px;border-left:5px solid #56fcff; color: #fff; padding-left: 10px; margin-top: 20px"
                    >
                        {{ yearMonth }}电量
                    </div>
                    <div style="text-align: right; margin-bottom: 10px">
                        <el-button
                            class="leader-common-button"
                            @click="showMonthChart('chart')"
                            >图表</el-button
                        >
                        <el-button
                            class="leader-common-button"
                            @click="showMonthChart('table')"
                            >数据</el-button
                        >
                        <!-- <el-button
                            class="leader-common-button"
                            @click="exportDayPowerAndCost"
                            >导出</el-button
                        > -->
                    </div>
                    <v-chart
                        :auto-resize="true"
                        :options="barMonth"
                        ref="barMonth"
                        theme="ovilia-green"
                        v-if="showMonthCharts"
                        @click="clickMonthBar"
                    />
                    <common-table
                        :tableData="tableMonthData"
                        :columns="colsMonth"
                        v-else
                    ></common-table>
                </template>

                <template v-if="showDay">
                    <div
                        style="text-align: left; font-size: 16px;border-left:5px solid #56fcff; color: #fff; margin-top: 20px; padding-left: 10px"
                    >
                        {{ monthDay }}电量
                    </div>
                    <div style="text-align: right; margin-bottom: 10px">
                        <el-button
                            class="leader-common-button"
                            @click="showDayChart('chart')"
                            >图表</el-button
                        >
                        <el-button
                            class="leader-common-button"
                            @click="showDayChart('table')"
                            >数据</el-button
                        >
                        <!-- <el-button
                            class="leader-common-button"
                            @click="exportHourPowerAndCost"
                            >导出</el-button
                        > -->
                    </div>
                    <v-chart
                        :auto-resize="true"
                        :options="barDay"
                        ref="barDay"
                        theme="ovilia-green"
                        v-if="showDayCharts"
                    />
                    <common-table
                        :tableData="tableDayData"
                        :columns="colsDay"
                        v-else
                    ></common-table>
                </template>
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import CommonTable from "@/comon/components/common-table.vue";
import * as api from "@/http/hr";
import { getAccounts, getSysDate } from "@/http/api";
import utils from "@/utils/utils";
import moment from "moment";
export default {
    components: { CommonTable },
    props: {
        date: {
            type: String,
            required: true
        },
        account_id: {
            type: String,
            required: true
        }
    },
    created() {
        // 获取系统时间
        this.getSysDate();
    },
    data() {
        return {
            activeName: "first",
            selectAccount: "", //选择的户号
            selectAccountId: "", //选择的户号id
            accounts: [], //户号列表
            sysDate: "", //系统时间
            searchForm: {
                selectDate: "" //选择的时间
            },
            pickerDisabled: {
                disabledDate: time => {
                    return (
                        time.getTime() >
                        new Date(
                            new Date(this.sysDate).toLocaleDateString()
                        ).getTime()
                    );
                }
            },
            searchFormRule: {
                selectDate: [
                    {
                        required: true,
                        message: "时间不能为空",
                        trigger: "change"
                    }
                ]
            },
            //年月图表------------start-----
            showYearCharts: true, //是否显示年月图表
            tableYearData: [], //年月图表数据
            colsYear: [
                { prop: "date", label: "日期" },
                { prop: "sharp", label: "尖电量" },
                { prop: "peak", label: "峰电量" },
                { prop: "off", label: "平电量" },
                { prop: "shoulder", label: "谷电量" },
                { prop: "total", label: "总电量" }
            ],
            xAxisYear: [],
            yAxisYearSharp: [], // 年尖时刻
            yAxisYearPeak: [], // 年峰时刻
            yAxisYearOff: [], // 年平时刻
            yAxisYearShoulder: [], // 年谷时刻
            yAxisYearTotal: [],
            //年月图表------------end-----
            //月日图表------------start-----
            showMonth: false, //是否显示月日图表
            showMonthCharts: false, //是否显示月日图表
            yearMonth: "", //年月
            tableMonthData: [], //月日图表数据
            colsMonth: [
                { prop: "date", label: "日期" },
                { prop: "sharp", label: "尖电量" },
                { prop: "peak", label: "峰电量" },
                { prop: "off", label: "平电量" },
                { prop: "shoulder", label: "谷电量" },
                { prop: "total", label: "总电量" }
            ],
            xAxisMonth: [],
            yAxisMonthSharp: [], // 年尖时刻
            yAxisMonthPeak: [], // 年峰时刻
            yAxisMonthOff: [], // 年平时刻
            yAxisMonthShoulder: [], // 年谷时刻
            yAxisMonthTotal: [],
            //月日图表------------end-----
            //日时图表------------end-----
            showDay: false, //是否显示小时图表
            showDayCharts: false, //是否显示月日图表
            monthDay: "", //月
            tableDayData: [], //日图表数据
            colsDay: [
                { prop: "date", label: "日期" },
                { prop: "sharp", label: "尖电量" },
                { prop: "peak", label: "峰电量" },
                { prop: "off", label: "平电量" },
                { prop: "shoulder", label: "谷电量" },
                { prop: "total", label: "总电量" }
            ],
            xAxisDay: [],
            yAxisDaySharp: [], // 年尖时刻
            yAxisDayPeak: [], // 年峰时刻
            yAxisDayOff: [], // 年平时刻
            yAxisDayShoulder: [], // 年谷时刻
            yAxisDaysTotal: []
            //日时图表------------start-----
        };
    },
    methods: {
        // 获取户号列表
        getAccounts() {
            getAccounts().then(res => {
                if (res && res.error_code === "0") {
                    this.accounts = res.bus_json;
                    this.selectAccount = res.bus_json[0].account_name;
                    this.selectAccountId =
                        res.bus_json[0].elec_customer_account_id;
                    this.getMonthPowerAndCost();
                }
            });
        },
        // 获取系统时间
        getSysDate() {
            getSysDate().then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.selectDate = res.bus_json.sysdate3;
                    this.sysDate = res.bus_json.sysdate3;

                    // 获取户号
                    this.getAccounts();
                }
            });
        },
        // 上一月
        frontMonthClick() {
            this.showDay = false;
            this.showMonth = false;
            const now = moment(this.searchForm.selectDate);
            this.searchForm.selectDate = now
                .subtract(1, "months")
                .format("YYYY-MM");
            this.getMonthPowerAndCost();
            this.showYearChart('chart')
       
        },
        //下一月
        nextMonthClick() {
            this.showDay = false;
            this.showMonth = false;
            const now = moment(this.searchForm.selectDate);
            this.searchForm.selectDate = now.add(1, "months").format("YYYY-MM");
            this.getMonthPowerAndCost();
            this.showYearChart('chart')
        },
        // 查询
        search() {
            this.showDay = false;
            this.showMonth = false;
            this.$refs["searchForm"].validate(valid => {
                if (valid) {
                    this.getMonthPowerAndCost();
                    this.showYearChart('chart')
                }
            });
        },
        // 获取一年的目录电量
        getMonthPowerAndCost() {
            api.getMonthPowerAndCost({
                elec_customer_account_id: this.selectAccountId,
                show_month: this.searchForm.selectDate
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxisYear = res.bus_json.x_list;
                    this.yAxisYearSharp = res.bus_json.sharp_power_list;
                    this.yAxisYearPeak = res.bus_json.peak_power_list;
                    this.yAxisYearOff = res.bus_json.off_power_list;
                    this.yAxisYearShoulder = res.bus_json.shoulder_power_list;
                    this.yAxisYearTotal = res.bus_json.total_power_list;
                }
            });
        },
        exportMonthPowerAndCost() {
            api.exportMonthPowerAndCost({
                elec_customer_account_id: this.selectAccountId,
                show_month: this.searchForm.selectDate,
                type: 1
            }).then(res => {
                const content = res;
                const blob = new Blob([content]);
                const fileName = "目录电量" + ".xlsx";
                if ("download" in document.createElement("a")) {
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                } else {
                    navigator.msSaveBlob(blob, fileName);
                }
            });
        },
        // 年图表数据转换
        showYearChart(type) {
            this.tableYearData = [];
            for (let i = 0; i < this.xAxisYear.length; i++) {
                let obj = {};
                obj.date = this.xAxisYear[i];
      
                obj.sharp =
                    this.yAxisYearSharp[i] +
                    this.getPercent(
                        this.yAxisYearSharp[i],
                        this.yAxisYearTotal[i]
                    );
                obj.peak =
                    this.yAxisYearPeak[i] +
                    this.getPercent(
                        this.yAxisYearPeak[i],
                        this.yAxisYearTotal[i]
                    );
                obj.off =
                    this.yAxisYearOff[i] +
                    this.getPercent(
                        this.yAxisYearOff[i],
                        this.yAxisYearTotal[i]
                    );
                obj.shoulder =
                    this.yAxisYearShoulder[i] +
                    this.getPercent(
                        this.yAxisYearShoulder[i],
                        this.yAxisYearTotal[i]
                    );
                obj.total = this.yAxisYearTotal[i];
                this.tableYearData.push(obj);
            }

            if (type === "chart") {
                this.showYearCharts = true;
            } else {
                this.showYearCharts = false;
         
            }
        },
        //年柱状图点击事件
        clickYearBar(params) {
            this.yearMonth = params.name;
            this.showMonth = true;
            this.showMonthCharts = true;
            this.showDay = false;
            this.getDayPowerAndCost(this.yearMonth);
        },
        // 获取月度数据
        getDayPowerAndCost(date) {
            api.getDayPowerAndCost({
                elec_customer_account_id: this.selectAccountId,
                show_month: date
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxisMonth = res.bus_json.x_list;
                    this.yAxisMonthSharp = res.bus_json.sharp_power_list;
                    this.yAxisMonthPeak = res.bus_json.peak_power_list;
                    this.yAxisMonthOff = res.bus_json.off_power_list;
                    this.yAxisMonthShoulder = res.bus_json.shoulder_power_list;
                    this.yAxisMonthTotal = res.bus_json.total_power_list;
                }
            });
        },
        exportDayPowerAndCost() {
            api.exportDayPowerAndCost({
                elec_customer_account_id: this.selectAccountId,
                show_month: this.yearMonth,
                type: 1
            }).then(res => {
                const content = res;
                const blob = new Blob([content]);
                const fileName = this.yearMonth + "目录电量" + ".xlsx";
                if ("download" in document.createElement("a")) {
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                } else {
                    navigator.msSaveBlob(blob, fileName);
                }
            });
        },
        // 月图表数据转换
        showMonthChart(type) {
            this.tableMonthData = [];
            for (let i = 0; i < this.xAxisMonth.length; i++) {
                let obj = {};
                obj.date = this.xAxisMonth[i];
                obj.sharp =
                    this.yAxisMonthSharp[i] +
                    this.getPercent(
                        this.yAxisMonthSharp[i],
                        this.yAxisMonthTotal[i]
                    );
                obj.peak =
                    this.yAxisMonthPeak[i] +
                    this.getPercent(
                        this.yAxisMonthPeak[i],
                        this.yAxisMonthTotal[i]
                    );
                obj.off =
                    this.yAxisMonthOff[i] +
                    this.getPercent(
                        this.yAxisMonthOff[i],
                        this.yAxisMonthTotal[i]
                    );
                obj.shoulder =
                    this.yAxisMonthShoulder[i] +
                    this.getPercent(
                        this.yAxisMonthShoulder[i],
                        this.yAxisMonthTotal[i]
                    );
                obj.total = this.yAxisMonthTotal[i];
                this.tableMonthData.push(obj);
            }

            if (type === "chart") {
                this.showMonthCharts = true;
            } else {
                this.showMonthCharts = false;
           
            }
           
        },
        clickMonthBar(params) {
            this.monthDay = params.name;
            this.showDay = true;
            this.showDayCharts = true;
            this.getHourPowerAndCost(this.monthDay);
        },
        // 获取小时数据
        getHourPowerAndCost(date) {
            api.getHourPowerAndCost({
                elec_customer_account_id: this.selectAccountId,
                show_day: date
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxisDay = res.bus_json.x_list;
                    this.yAxisDaySharp = res.bus_json.sharp_power_list;
                    this.yAxisDayPeak = res.bus_json.peak_power_list;
                    this.yAxisDayOff = res.bus_json.off_power_list;
                    this.yAxisDayShoulder = res.bus_json.shoulder_power_list;
                    this.yAxisDaysTotal = res.bus_json.total_power_list;
                }
            });
        },
        exportHourPowerAndCost() {
            api.exportHourPowerAndCost({
                elec_customer_account_id: this.selectAccountId,
                show_day: this.monthDay,
                type: 1
            }).then(res => {
                const content = res;
                const blob = new Blob([content]);
                const fileName = this.monthDay + "目录电量" + ".xlsx";
                if ("download" in document.createElement("a")) {
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                } else {
                    navigator.msSaveBlob(blob, fileName);
                }
            });
        },
        // 小时图表数据转换
        showDayChart(type) {
            this.tableDayData = [];
            for (let i = 0; i < this.xAxisDay.length; i++) {
                let obj = {};
                obj.date = this.xAxisDay[i];
                obj.sharp =
                    this.yAxisDaySharp[i] +
                    this.getPercent(
                        this.yAxisDaySharp[i],
                        this.yAxisDaysTotal[i]
                    );
                obj.peak =
                    this.yAxisDayPeak[i] +
                    this.getPercent(
                        this.yAxisDayPeak[i],
                        this.yAxisDaysTotal[i]
                    );
                obj.off =
                    this.yAxisDayOff[i] +
                    this.getPercent(
                        this.yAxisDayOff[i],
                        this.yAxisDaysTotal[i]
                    );
                obj.shoulder =
                    this.yAxisDayShoulder[i] +
                    this.getPercent(
                        this.yAxisDayShoulder[i],
                        this.yAxisDaysTotal[i]
                    );
                obj.total = this.yAxisDaysTotal[i];
                this.tableDayData.push(obj);
            }

            if (type === "chart") {
                this.showDayCharts = true;
            } else {
                this.showDayCharts = false;
            }
        },
        toggleTab(val) {
            this.selectAccountId = val;
            this.search();
            // this.showYearCharts = true;
        },
        getPercent(value, total) {
            if (parseFloat(value) == 0) {
                return " (0%)";
            } else {
                const per = (parseFloat(value) / parseFloat(total)) * 100;
                return ` (${per.toFixed(2)}%)`;
            }
        }
    },
    computed: {
        barYear() {
            const options = {
                grid: {
                    left: "1%",
                    right: "2%",
                    bottom: "5%",
                    top: "10%",
                    containLabel: true
                },

                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["尖电量", "峰电量", "平电量", "谷电量"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                color: ["#fe7f65", "#ffcb4f", "#0091e9", "#2ab85c", "#ffffff"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "月",
                        data: this.xAxisYear,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位: kW·h",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "尖电量",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#F97464'
                                }, {
                                    offset: 1,
                                    color: '#FB3737'
                                }]),
                            }
                        },
                        data: this.yAxisYearSharp
                    },
                    {
                        name: "峰电量",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#F5E3B7'
                                }, {
                                    offset: 1,
                                    color: '#CB7A07'
                                }]),
                            }
                        },
                        data: this.yAxisYearPeak
                    },
                    {
                        name: "平电量",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#06B4F9'
                                }, {
                                    offset: 1,
                                    color: '#092856'
                                }]),
                            }
                        },
                        data: this.yAxisYearOff
                    },
                    {
                        name: "谷电量",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#8CCFA5'
                                }, {
                                    offset: 1,
                                    color: '#1F924A'
                                }]),
                            }
                        },
                        data: this.yAxisYearShoulder
                    },
                    {
                        name: "总电量",
                        type: "line",
                        lineStyle: {
                            opacity: 0
                        },
                        label: {
                            show: true,
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        data: this.yAxisYearTotal,
                        smooth: true,
                        symbol: "none"
                    }
                ]
            };
            return options;
        },
        barMonth() {
            const options = {
                grid: {
                    left: "1%",
                    right: "2%",
                    bottom: "5%",
                    top: "10%",
                    containLabel: true
                },

                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["尖电量", "峰电量", "平电量", "谷电量"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                color: ["#fe7f65", "#ffcb4f", "#0091e9", "#2ab85c", "#ffffff"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "日",
                        // axisLabel: {
                        //     rotate: -45,
                        // },
                        data: this.xAxisMonth,
                        axisLabel: {
                            rotate: -45,
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位: kW·h",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "尖电量",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#F97464'
                                }, {
                                    offset: 1,
                                    color: '#FB3737'
                                }]),
                            }
                        },
                        data: this.yAxisMonthSharp
                    },
                    {
                        name: "峰电量",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#F5E3B7'
                                }, {
                                    offset: 1,
                                    color: '#CB7A07'
                                }]),
                            }
                        },
                        data: this.yAxisMonthPeak
                    },
                    {
                        name: "平电量",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#06B4F9'
                                }, {
                                    offset: 1,
                                    color: '#092856'
                                }]),
                            }
                        },
                        data: this.yAxisMonthOff
                    },
                    {
                        name: "谷电量",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#8CCFA5'
                                }, {
                                    offset: 1,
                                    color: '#1F924A'
                                }]),
                            }
                        },
                        data: this.yAxisMonthShoulder
                    },
                    {
                        name: "总电量",
                        type: "line",
                        lineStyle: {
                            opacity: 0
                        },
                        label: {
                            show: true,
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        smooth: true,
                        symbol: "none",
                        data: this.yAxisMonthTotal
                    }
                ]
            };
            return options;
        },
        barDay() {
            const options = {
                grid: {
                    left: "1%",
                    right: "2%",
                    bottom: "5%",
                    top: "10%",
                    containLabel: true
                },

                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["尖电量", "峰电量", "平电量", "谷电量"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                color: ["#fe7f65", "#ffcb4f", "#0091e9", "#2ab85c", "#ffffff"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "小时",
                        data: this.xAxisDay,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位: kW·h",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "尖电量",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#F97464'
                                }, {
                                    offset: 1,
                                    color: '#FB3737'
                                }]),
                            }
                        },
                        data: this.yAxisDaySharp
                    },
                    {
                        name: "峰电量",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#F5E3B7'
                                }, {
                                    offset: 1,
                                    color: '#CB7A07'
                                }]),
                            }
                        },
                        data: this.yAxisDayPeak
                    },
                    {
                        name: "平电量",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#06B4F9'
                                }, {
                                    offset: 1,
                                    color: '#092856'
                                }]),
                            }
                        },
                        data: this.yAxisDayOff
                    },
                    {
                        name: "谷电量",
                        type: "bar",
                        stack: "one",
                        barWidth: "50%",
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#8CCFA5'
                                }, {
                                    offset: 1,
                                    color: '#1F924A'
                                }]),
                            }
                        },  
                        data: this.yAxisDayShoulder
                    },
                    {
                        name: "总电量",
                        type: "line",
                        lineStyle: {
                            opacity: 0
                        },
                        label: {
                            show: true,
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        smooth: true,
                        symbol: "none",
                        data: this.yAxisDaysTotal
                    }
                ]
            };
            return options;
        }
    },
    watch: {
        // date: {
        //     handler(newValue) {
        //         this.date = newValue;
        //         if (this.date && this.account_id) {
        //             this.getMonthPowerAndCost();
        //         }
        //     },
        //     deep: true,
        //     immediate: true,
        // },
        // account_id: {
        //     handler(newValue) {
        //         this.account_id = newValue;
        //         if (this.account_id && this.date) {
        //             this.getMonthPowerAndCost();
        //         }
        //     },
        //     deep: true,
        //     immediate: true,
        // },
    }
};
</script>
<style lang="scss">
.incoming-wrap {
    width: 100%;
    height: 100%;
    padding: 0 px2Rem(40px);
    box-sizing: border-box;
    .echart-container {
        width: 100%;
        height: 100%;
        .echarts {
            width: 100%;
            height: px2Rem(320px);
        }
    }
}
  .incoming-wrap .echart-container .echarts{height:20.5rem!important;}

  .el-table__body-wrapper{overflow-y: scroll!important;;}
</style>
